import { GOOGLE_FEEDBACK_SHEET_URL } from "./constants";

export interface FeedbackPayload {
  rating: string;
  positiveFeedback: string[];
  improvementAreas: string[];
  comment?: string;
  bookingReference?: string;
  userEmail?: string;
}

/**
 * Submits user booking feedback to the configured Google Sheet Web App endpoint.
 */
export const submitFeedbackToGoogleSheet = async (payload: FeedbackPayload): Promise<boolean> => {
  if (!GOOGLE_FEEDBACK_SHEET_URL || GOOGLE_FEEDBACK_SHEET_URL.includes("YOUR_GOOGLE_APPS_SCRIPT")) {
    console.warn("Google Feedback Sheet URL placeholder is not configured yet. Payload:", payload);
    return false;
  }

  try {
    await fetch(GOOGLE_FEEDBACK_SHEET_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      },
      body: JSON.stringify(payload),
    });
    return true;
  } catch (err) {
    console.error("Error submitting feedback to Google Sheet:", err);
    return false;
  }
};
